var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"camera-wrapper"},[_c('div',{style:({height: _vm.height+'px'}),attrs:{"id":_vm._cameraId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }